import { ecommerce } from 'config/constants';

const _getTotalizerValue = (totalizers, id) => {
    const items = totalizers ? totalizers.filter(item => item.id === id) : [];
    return items[0] ? Math.abs(items[0].value) : 0;
};

const getTotalizer = (totalizers) => {
    if(!totalizers) return null;

    const discount = _getTotalizerValue(totalizers, 'Discounts');
    const subTotal = _getTotalizerValue(totalizers, 'Items');
    const shipping = _getTotalizerValue(totalizers, 'Shipping');
    const total = (subTotal - discount) + shipping;
    const totalTcenco = (_getTotalizerValue(totalizers, 'Tcenco') + shipping);

    return {
        discount,
        subTotal,
        shipping,
        total,
        totalTcenco
    }
};


const setSlaDeliveryWindow = (logisticsInfo, deliveryWindow, deliveryType, addressId = null, isSellerFood = null, express = null) => {
    if(logisticsInfo){
        let selectedSla = '';
        let deliveryChannel = 'pickup-in-point';

        if (deliveryType === 'seller-1-sla-DespachoaDomicilio' || deliveryType === 'seller-1-sla-Express') {
            deliveryChannel = 'delivery';
        }
        let newInfo = logisticsInfo.map(options => {
            options.deliveryWindow = deliveryWindow;

            options.slas = options.slas.map(sla => {
                sla.selectedSla = 'Despacho Express';
                let conditionStore = null;
                let conditionCar = null
                let conditionDelivery = null;
                const validDeliverySpecial = sla.id.includes('Despacho Especial') && (options.slas.findIndex(item => item.id.includes('Despacho a Domicilio')) === -1);

                if(ecommerce.whiteLabel){
                    conditionStore = (((addressId && sla.id.includes(addressId) && sla.id.includes('Retiro en Tienda')) || (!addressId && isSellerFood && sla.id.includes('Retiro en Tienda'))) && (deliveryType === 'seller-1-sla-RetiroenTienda'))
                    conditionCar = (((addressId && sla.id.includes(addressId) && sla.id.includes('Click al Auto')) || (!addressId && sla.id.includes('Click al Auto'))) && (deliveryType === 'seller-1-sla-ClickalAuto'))
                    conditionDelivery = ((sla.id.includes('Despacho a Domicilio') || validDeliverySpecial) && deliveryType === 'seller-1-sla-DespachoaDomicilio')
                }else{
                    conditionStore = (((!isSellerFood && sla.id.includes(addressId)) || (isSellerFood && sla.id.includes('Retiro en Tienda'))) && (deliveryType === 'seller-1-sla-RetiroenTienda'))
                    conditionCar = (sla.id.includes('Click al Auto') && deliveryType === 'seller-1-sla-ClickalAuto');
                    conditionDelivery = ((sla.id.includes('Despacho a Domicilio') || validDeliverySpecial) && ((deliveryType === 'seller-1-sla-DespachoaDomicilio' || deliveryType === 'seller-1-sla-Express') && !(express && express.selected) ))
                }

                if (conditionStore) {
                    sla.deliveryWindow = deliveryWindow;
                    sla.selectedSla = sla.id;
                    sla.selectedDeliveryChannel = deliveryChannel;
                    selectedSla = sla.id;
                }
                if (conditionCar) {
                    sla.deliveryWindow = deliveryWindow;
                    sla.selectedSla = sla.id;
                    sla.selectedDeliveryChannel = deliveryChannel;
                    selectedSla = sla.id;
                }
                if (conditionDelivery) {
                    sla.deliveryWindow = deliveryWindow;
                    sla.selectedSla = sla.id;
                    sla.selectedDeliveryChannel = deliveryChannel;
                    selectedSla = sla.id;
                }
                if ((sla.id.includes('Despacho Express')) && (express && express.selected)) {
                    sla.deliveryWindow = null;
                    sla.selectedSla = sla.id;
                    sla.selectedDeliveryChannel = deliveryChannel;
                    selectedSla = sla.id;
                }
                return sla;
            });

            options.selectedSla = selectedSla;
            options.selectedDeliveryChannel = deliveryChannel;

            return options;
        });
        return newInfo;
    }else{
        return null;
    }
}

const CartFactory = {
    getTotalizer,
    setSlaDeliveryWindow
};

export default CartFactory;
